import { render, staticRenderFns } from "./Newtoexamine.vue?vue&type=template&id=26876874"
import script from "./Newtoexamine.vue?vue&type=script&lang=js"
export * from "./Newtoexamine.vue?vue&type=script&lang=js"
import style0 from "./Newtoexamine.vue?vue&type=style&index=0&id=26876874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports